"use client";

import { c as _c } from "react/compiler-runtime";
import { useFirstStepForm } from "app/form/[formId]/(formTemplate)/firstStep/firstStepForm/useFirstStepForm";
import { usePracujMobileCandidate } from "app/form/[formId]/(formTemplate)/firstStep/firstStepForm/usePracujMobileCandidate";
import type { FirstStepProps } from "app/form/[formId]/(formTemplate)/firstStep/types";
import { FormModeProvider } from "forms/contexts/useFormModeContext";
import { FormStatusProvider, useFormStatusContext } from "forms/contexts/useFormStatusContext";
import useRenderFields from "forms/hooks/useRenderFields";
import { questionNames } from "types/QuestionNames";
import { Form } from "uiShadcn/form";
import SubmitButton from "./SubmitButton";
function FormContent(t0) {
  const $ = _c(23);
  const {
    uiSchema,
    jsonSchema,
    formId,
    candidateData,
    isTwoStepForm
  } = t0;
  let t1;
  if ($[0] !== candidateData || $[1] !== formId || $[2] !== isTwoStepForm || $[3] !== jsonSchema || $[4] !== uiSchema) {
    t1 = {
      formId,
      uiSchema,
      jsonSchema,
      candidateData,
      isTwoStepForm
    };
    $[0] = candidateData;
    $[1] = formId;
    $[2] = isTwoStepForm;
    $[3] = jsonSchema;
    $[4] = uiSchema;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    formRef,
    isSubmitting,
    form,
    onSubmitHandler,
    shouldRenderSecondStep,
    uiFields: t2,
    renderSubmitButton
  } = useFirstStepForm(t1);
  const uiFields = t2 === undefined ? [] : t2;
  const {
    isLoading
  } = useFormStatusContext();
  const {
    renderFields
  } = useRenderFields();
  const defaultCV = candidateData?.defaultCv ? new File([], `${candidateData.defaultCv?.name}.${candidateData?.defaultCv?.format}`) : null;
  const defaults = {
    [questionNames.CvFile]: defaultCV
  };
  const T0 = Form;
  let t3;
  if ($[6] !== form || $[7] !== onSubmitHandler) {
    t3 = form.handleSubmit(onSubmitHandler);
    $[6] = form;
    $[7] = onSubmitHandler;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = "flex flex-col items-center justify-center gap-n10";
  const t5 = "on";
  const t6 = true;
  const t7 = renderFields({
    fields: uiFields,
    control: form.control,
    jsonSchema,
    defaults
  });
  let t8;
  if ($[9] !== isLoading || $[10] !== isSubmitting || $[11] !== renderSubmitButton || $[12] !== shouldRenderSecondStep) {
    t8 = renderSubmitButton && <SubmitButton isLoading={isLoading} isSubmitting={isSubmitting} shouldRenderSecondStep={shouldRenderSecondStep} />;
    $[9] = isLoading;
    $[10] = isSubmitting;
    $[11] = renderSubmitButton;
    $[12] = shouldRenderSecondStep;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== formRef || $[15] !== t3 || $[16] !== t7 || $[17] !== t8) {
    t9 = <form ref={formRef} onSubmit={t3} className={t4} autoComplete={t5} noValidate={t6}>{t7}{t8}</form>;
    $[14] = formRef;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== T0 || $[20] !== form || $[21] !== t9) {
    t10 = <T0 {...form}>{t9}</T0>;
    $[19] = T0;
    $[20] = form;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function FirstStepForm(props) {
  const $ = _c(9);
  const {
    candidateData: candidateDateMobile,
    isFetching
  } = usePracujMobileCandidate();
  let t0;
  if ($[0] !== candidateDateMobile || $[1] !== isFetching || $[2] !== props) {
    t0 = !isFetching && <FormContent {...props} candidateData={props?.candidateData ?? candidateDateMobile} />;
    $[0] = candidateDateMobile;
    $[1] = isFetching;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <FormStatusProvider>{t0}</FormStatusProvider>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props.formMode || $[7] !== t1) {
    t2 = <FormModeProvider mode={props.formMode}>{t1}</FormModeProvider>;
    $[6] = props.formMode;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export default FirstStepForm;